import { render, staticRenderFns } from "./CreateDialogMedia.vue?vue&type=template&id=3a8152cc&scoped=true"
import script from "./CreateDialogMedia.ts?vue&type=script&lang=ts&external"
export * from "./CreateDialogMedia.ts?vue&type=script&lang=ts&external"
import style0 from "./CreateDialogMedia.scss?vue&type=style&index=0&id=3a8152cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8152cc",
  null
  
)

export default component.exports